import type { ItemState } from './@types/ItemState'
import type { SliceItems, SliceListItems } from './@types/SliceItems'
import type { ListItemId } from './@types/SliceMutators'
import { DEFAULT_DATA_ITEM, DEFAULT_ITEM_STATE } from './constants'

const mutateItem = <T extends { id: string }>(id: T['id'], item?: Partial<ItemState<T>>) => {
  return (currentState: SliceItems<T, ItemState<T>>) => ({
    items: {
      ...currentState.items,
      [id]: {
        ...DEFAULT_DATA_ITEM,
        ...currentState?.items?.[id],
        ...item,
      },
    },
  })
}

export const mutateListItem = <S>(id: ListItemId, item?: Partial<S>) => {
  return (currentState: SliceListItems<S>) => ({
    items: {
      ...currentState.items,
      [id]: {
        ...DEFAULT_ITEM_STATE,
        ...currentState?.items?.[id],
        ...item,
      },
    },
  })
}

export default mutateItem
